<template>
<div>
	<wrapper-edit
      :wrapper-width="wrapperWidth"
      @back="paasPageBack">
    <Form ref="paasForm" slot="form"
            :model="paasFormData"
            :rules="paasFormRules"
            :label-width="130">
       <Row>
       <FormItem label="会员名称：" prop="name" class="ivu-col-span-24" >
          <Input v-model="paasFormData.name"  clearable ></Input>
       </FormItem>
       </Row>
       <Row>
       <FormItem label="是否为永久会员：" prop="isForever" class="ivu-col-span-24" >
		      <Enum :enumJsonKey="'crmdict-yesOrNo'"  v-model="paasFormData.isForever"  type="radio" ></Enum>
	     </FormItem>
       </Row>
       <Row>
       <FormItem label="购买金额：" prop="money" class="ivu-col-span-24" >
          <InputNumber v-model="paasFormData.money"></InputNumber>
       </FormItem>
       </Row>
       <Row>
       <FormItem label="是否购买：" prop="isPay" class="ivu-col-span-24" >
		      <Enum :enumJsonKey="'crmdict-yesOrNo'"  v-model="paasFormData.isPay"  type="radio" ></Enum>
		   </FormItem>
       </Row>
       <Row>
          <FormItem label="有效时间(天)：" prop="validDate" class="ivu-col-span-8" >
            <InputNumber v-model="paasFormData.validDate"></InputNumber>
          </FormItem>
          <FormItem label="会员等级（必须唯一）：" prop="gradeLevel" class="ivu-col-span-8" >
            <InputNumber v-model="paasFormData.gradeLevel"></InputNumber>
          </FormItem>
          <FormItem label="享受折扣：" prop="discount" class="ivu-col-span-8" >
            <InputNumber v-model="paasFormData.discount"></InputNumber>
          </FormItem>
       </Row>
      <Row>
        <FormItem label="图标:"  class="ivu-col-span-24">
          <div class="file-upload-list" v-if="paasFormData.levelIcon">
            <template>
              <img :src="paasFormData.levelIcon">
              <div class="file-upload-list-cover">
                <Icon type="ios-eye-outline" @click.native="handleView(paasFormData.levelIcon)"></Icon>
                <Icon type="ios-trash-outline" @click.native="handleRemove(paasFormData.deleteIconUrl,'levelIcon')"></Icon>
              </div>
            </template>
          </div>
          <div class="fc-upload-btn" ref="uploadIconBtn" @click="openUploadPanel('levelIcon','uploadIconBtn')"
               v-if="!paasFormData.levelIcon && paasFormData.levelIcon === ''">
            <Icon type="md-camera" size="20"/>
          </div>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="会员背景:"  class="ivu-col-span-24">
          <div class="file-upload-list" v-if="paasFormData.levelBg">
            <template>
              <img :src="paasFormData.levelBg">
              <div class="file-upload-list-cover">
                <Icon type="ios-eye-outline" @click.native="handleView(paasFormData.levelBg)"></Icon>
                <Icon type="ios-trash-outline" @click.native="handleRemove(paasFormData.deleteBgUrl,'levelBg')"></Icon>
              </div>
            </template>
          </div>
          <div class="fc-upload-btn" ref="uploadBgBtn" @click="openUploadPanel('levelBg','uploadBgBtn')"
               v-if="!paasFormData.levelBg && paasFormData.levelBg === ''">
            <Icon type="md-camera" size="20"/>
          </div>
        </FormItem>
      </Row>
       <Row>
       <FormItem label="是否显示：" prop="isShow" class="ivu-col-span-24" >
		      <Enum :enumJsonKey="'crmdict-isShow'"  v-model="paasFormData.isShow"  type="radio" ></Enum>
		   </FormItem>
       </Row>
       <Row>
       <FormItem label="说明：" prop="explainDesc" class="ivu-col-span-24" >
		      <Input v-model="paasFormData.explainDesc" type="textarea"  clearable ></Input>
	     </FormItem>
       </Row>
       <div class="edit-oper-toolbar">
	      <Button type="primary" @click="paasFormSubmit('paasForm','','add')">保存并继续添加</Button>
	      <Button @click="paasFormSubmit('paasForm','','systemUserLevelList')" style="margin-left: 8px">保存并返回</Button>
	      <Button @click="paasPageBack" style="margin-left: 8px">返回</Button>
	    </div>
      <FileModal id="fileModal"
                 @save-file="saveFileData"
                 thumbnailWidth="180"
                 thumbnailHeight="100"
                 :uploadParams="uploadParams"
                 :uploadAction="uploadAction"
                 @on-close="hiddenModal"
                 v-if="uploadModal"
                 class="paas-file-select" ></FileModal>
    </Form>
  </wrapper-edit>
</div>
</template>
<script>
import wrapperEdit from "@components/paas/wrapper-edit";
import metaEdit from "@assets/js/meta-edit.js";
import Enum from '@components/paas/enum-form' //枚举渲染
import FileModal from '@views/sys/image/select'
 
export default {
   name: "edit",
   mixins:[metaEdit],
   components:{wrapperEdit,Enum,FileModal},
   data(){
     return {
     	serviceUrl:"/eb/user/level",  //每个页面访问后台服务器的路径
      	currentIdFiledName: 'id',
        paasFormData:{
        	id:'',
        	isForever:'',
          gradeLevel:'',
        	name:'',
        	image:'',
        	addTime:'',
        	validDate:'',
        	icon:'',
        	money:'',
        	isDel:'',
        	merId:'',
          explainDesc:'',
        	discount:'',
        	isPay:'',
        	isShow:'',
          levelIcon:'',
          levelBg:'',
          deleteIconUrl:'',
          deleteBgUrl:'',
          fileData:'',
        },
        fileList:[],
        paasFormRules:{
        },
		    redirectName:"systemUserLevelList",
        nextAddName:"systemUserLevelEdit",
        uploadModal:false,
        uploadParams: {
           fileBusinessType: 'systemUserLevel',
           fileBusinessProp: '',
           fileBusinessId: '',
         },
     }
   },
  computed:{
    uploadAction(){
      return this.$store.state.sysApi+'/sys/image/uploadAttacheSlice';
    }
  },
   methods:{
     /**
      * 保存前逻辑
      */
     paasFormSubmitBefore(){
       this.paasFormData.fileData = JSON.stringify(this.fileList);
     },
     /**
      * 进入edit后的逻辑
      * */
     createdCallback(data) {
       this.paasFormData.levelIcon = data.entity.levelIconFile.showUrl;
       this.paasFormData.deleteIconUrl = data.entity.levelIconFile.deleteUrl;
       this.paasFormData.levelBg = data.entity.levelBgFile.showUrl;
       this.paasFormData.deleteBgUrl = data.entity.levelBgFile.deleteUrl;
       this.uploadParams.fileBusinessId = data.paasRepeatSubmitFlag;
       console.log(this.paasFormData.deleteIconUrl);
       console.log(this.paasFormData.deleteBgUrl);
     },
     /**
      * 隐藏附件弹出框
      */
     hiddenModal(){
       this.uploadModal = false;
     },
     /**
      * 打开附件弹出框
      */
     openUploadPanel(prop,uploadBtn){
       ;
       this.uploadModal = true;
       this.uploadParams.fileBusinessProp = prop;
       //计算当前位置的top以及left
       let top = this.$refs[uploadBtn].getBoundingClientRect().top;
       this.$nextTick(()=>{
         document.getElementById("fileModal").style.top = top+"px";
         document.getElementById("fileModal").style.left = 0;
       });
     },
     /**
      * 选中附件后的操作
      * @param files
      */
     saveFileData(files){
       ;
       if(this.uploadParams.fileBusinessProp === "levelIcon"){
         this.paasFormData.levelIcon = files[0].showUrl;
         this.paasFormData.deleteIconUrl = "";
       }else{
         this.paasFormData.levelBg = files[0].showUrl;
         this.paasFormData.deleteBgUrl = "";
       }
       let fileParam = {
         files:files,
         prop:this.uploadParams.fileBusinessProp
       };
       this.fileList.push(fileParam);
       console.log(this.fileList);
       this.hiddenModal();
     },
     handleRemove (deleteUrl,prop) {
       if(deleteUrl && typeof(deleteUrl) !=="undefined"){
         this.axios.post(deleteUrl).then(res => {
           if(res.code === 200){
             this.paasFormData[prop] = "";
             this.$Message.success("附件删除成功");
           }
         }).catch(err =>{
           this.$Message.error('附件删除失败，请重试！');
         });
       }else{
         this.paasFormData[prop] = "";
       }
     },
   }
}
</script>
<style scope>
</style>
